import React from 'react';
import { PUBLIC_URL } from '../../config/env';

export const country =
    [
        {
            value: 355,
            "name": "AL",
            label: "AL(+355)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/al.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 49,
            "name": "DE",
            label: "DE(+49)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/de.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 376,
            "name": "AD",
            label: "AD(+376)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ad.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 244,
            "name": "AO",
            label: "AO(+244)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ao.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 966,
            "name": "SA",
            label: "SA(+966)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sa.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 54,
            "name": "AR",
            label: "AR(+54)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ar.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 374,
            "name": "AM",
            label: "AM(+374)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/am.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 97,
            "name": "AW",
            label: "AW(+97)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/aw.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 61,
            "name": "AU",
            label: "AU(+61)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/au.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 43,
            "name": "AT",
            label: "AT(+43)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/at.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1002,
            "name": "BS",
            label: "BS(+1002)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bs.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 880,
            "name": "BD",
            label: "BD(+880)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bd.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1003,
            "name": "BB",
            label: "BB(+1003)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bb.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 501,
            "name": "BZ",
            label: "BZ(+501)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bz.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 229,
            "name": "BJ",
            label: "BJ(+229)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bj.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 591,
            "name": "BO",
            label: "BO(+591)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bo.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 387,
            "name": "BA",
            label: "BA(+387)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ba.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 267,
            "name": "BW",
            label: "BW(+267)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bw.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 55,
            "name": "BR",
            label: "BR(+55)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/br.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 673,
            "name": "BN",
            label: "BN(+673)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 359,
            "name": "BG",
            label: "BG(+359)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bg.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 226,
            "name": "BF",
            label: "BF(+226)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bf.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 257,
            "name": "BI",
            label: "BI(+257)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/bi.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 32,
            "name": "BE",
            label: "BE(+32)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/be.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 238,
            "name": "CV",
            label: "CV(+238)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cv.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 237,
            "name": "CM",
            label: "CM(+237)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1,
            "name": "CA",
            label: "CA(+1)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ca.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 235,
            "name": "TD",
            label: "TD(+235)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/td.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 56,
            "name": "CL",
            label: "CL(+56)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cl.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 86,
            "name": "CN",
            label: "CN(+86)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 357,
            "name": "CY",
            label: "CY(+357)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cy.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 57,
            "name": "CO",
            label: "CO(+57)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + '/img/flags/co.svg'} alt=""
                           className={"flag"}
            />
        },
        {
            value: 850,
            "name": "KP",
            label: "KP(+850)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/kp.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 506,
            "name": "CR",
            label: "CR(+506)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 225,
            "name": "CI",
            label: "CI(+225)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ci.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 385,
            "name": "HR",
            label: "HR(+385)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/hr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 53,
            "name": "CU",
            label: "CU(+53)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cu.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 45,
            "name": "DK",
            label: "DK(+45)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/dk.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1007,
            "name": "DM",
            label: "DM(+1007)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/dm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 593,
            "name": "EC",
            label: "EC(+593)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ec.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 20,
            "name": "EG",
            label: "EG(+20)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/eg.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 503,
            "name": "SV",
            label: "SV(+503)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sv.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 421,
            "name": "SK",
            label: "SK(+421)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sk.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 34,
            "name": "ES",
            label: "ES(+34)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/es.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1,
            "name": "US",
            label: "US(+1)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/us.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 372,
            "name": "EE",
            label: "EE(+372)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ee.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 63,
            "name": "PH",
            label: "PH(+63)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ph.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 358,
            "name": "FI",
            label: "FI(+358)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/fi.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 33,
            "name": "FR",
            label: "FR(+33)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/fr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 220,
            "name": "GM",
            label: "GM(+220)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 995,
            "name": "GE",
            label: "GE(+995)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ge.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 233,
            "name": "GH",
            label: "GH(+233)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gh.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 350,
            "name": "GI",
            label: "GI(+350)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gi.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1009,
            "name": "GD",
            label: "GD(+1009)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gd.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 30,
            "name": "GR",
            label: "GR(+30)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 590,
            "name": "GP",
            label: "GP(+590)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gp.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1671,
            "name": "GU",
            label: "GU(+1671)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gu.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 502,
            "name": "GT",
            label: "GT(+502)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gt.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 224,
            "name": "GN",
            label: "GN(+224)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 240,
            "name": "GQ",
            label: "GQ(+240)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gq.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 245,
            "name": "GW",
            label: "GW(+245)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gw.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 592,
            "name": "GY",
            label: "GY(+592)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gy.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 504,
            "name": "HN",
            label: "HN(+504)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/hn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 852,
            "name": "HK",
            label: "HK(+852)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/hk.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 91,
            "name": "IN",
            label: "IN(+91)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/in.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 62,
            "name": "ID",
            label: "ID(+62)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/id.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 964,
            "name": "IQ",
            label: "IQ(+964)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/iq.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 353,
            "name": "IE",
            label: "IE(+353)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ie.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 98,
            "name": "IR",
            label: "IR(+98)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ir.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 354,
            "name": "IS",
            label: "IS(+354)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/is.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1006,
            "name": "KY",
            label: "KY(+1006)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ky.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 682,
            "name": "CK",
            label: "CK(+682)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ck.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 692,
            "name": "MH",
            label: "MH(+692)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mh.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 677,
            "name": "SB",
            label: "SB(+677)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sb.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 284,
            "name": "VG",
            label: "VG(+284)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/vg.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 972,
            "name": "IL",
            label: "IL(+972)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/il.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 39,
            "name": "IT",
            label: "IT(+39)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/it.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1010,
            "name": "JM",
            label: "JM(+1010)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/jm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 81,
            "name": "JP",
            label: "JP(+81)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/jp.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 962,
            "name": "JO",
            label: "JO(+962)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/jo.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 254,
            "name": "KE",
            label: "KE(+254)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ke.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 686,
            "name": "KI",
            label: "KI(+686)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ki.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 965,
            "name": "KW",
            label: "KW(+965)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/kw.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 856,
            "name": "LA",
            label: "LA(+856)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/la.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 266,
            "name": "LS",
            label: "LS(+266)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ls.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 231,
            "name": "LR",
            label: "LR(+231)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/lr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 218,
            "name": "LY",
            label: "LY(+218)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ly.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 417,
            "name": "LI",
            label: "LI(+417)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/li.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 370,
            "name": "LT",
            label: "LT(+370)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/lt.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 352,
            "name": "LU",
            label: "LU(+352)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/lu.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 853,
            "name": "MO",
            label: "MO(+853)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mo.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 261,
            "name": "MG",
            label: "MG(+261)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mg.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 60,
            "name": "MY",
            label: "MY(+60)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/my.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 265,
            "name": "MW",
            label: "MW(+265)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mw.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 960,
            "name": "MV",
            label: "MV(+960)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mv.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 356,
            "name": "MT",
            label: "MT(+356)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mt.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 223,
            "name": "ML",
            label: "ML(+223)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ml.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 212,
            "name": "MA",
            label: "MA(+212)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ma.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 230,
            "name": "MU",
            label: "MU(+230)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mu.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 222,
            "name": "MR",
            label: "MR(+222)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 2696,
            "name": "YT",
            label: "YT(+2696)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/yt.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 691,
            "name": "FM",
            label: "FM(+691)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/fm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 976,
            "name": "MN",
            label: "MN(+976)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1011,
            "name": "MS",
            label: "MS(+1011)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ms.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 258,
            "name": "MZ",
            label: "MZ(+258)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mz.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 95,
            "name": "MM",
            label:
                "MM(+95)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 52,
            "name": "MX",
            label: "MX(+52)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mx.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 377,
            "name": "MC",
            label: "MC(+377)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/mc.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 264,
            "name": "NA",
            label: "NA(+264)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/na.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 674,
            "name": "NR",
            label: "NR(+674)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/nr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 977,
            "name": "NP",
            label: "NP(+977)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/np.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 505,
            "name": "NI",
            label: "NI(+505)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ni.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 227,
            "name": "NE",
            label: "NE(+227)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ne.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 234,
            "name": "NG",
            label: "NG(+234)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ng.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 683,
            "name": "NU",
            label: "NU(+683)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/nu.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 47,
            "name": "NO",
            label: "NO(+47)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/no.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 687,
            "name": "NC",
            label: "NC(+687)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/nc.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 64,
            "name": "NZ",
            label: "NZ(+64)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/nz.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 968,
            "name": "OM",
            label: "OM(+968)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/om.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 92,
            "name": "PK",
            label: "PK(+92)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pk.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 507,
            "name": "PA",
            label: "PA(+507)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pa.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 595,
            "name": "PY",
            label: "PY(+595)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/py.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 51,
            "name": "PE",
            label: "PE(+51)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pe.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 689,
            "name": "PF",
            label: "PF(+689)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pf.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 48,
            "name": "PL",
            label: "PL(+48)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pl.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 351,
            "name": "PT",
            label: "PT(+351)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pt.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1787,
            "name": "PR",
            label: "PR(+1787)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/pr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 974,
            "name": "QA",
            label: "QA(+974)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/qa.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 44,
            "name": "GB",
            label: "GB(+44)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/gb.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 42,
            "name": "CZ",
            label: "CZ(+42)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/cz.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1008,
            "name": "DO",
            label: "DO(+1008)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/do.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 262,
            "name": "RE",
            label: "RE(+262)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/re.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 40,
            "name": "RO",
            label: "RO(+40)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ro.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 684,
            "name": "WS",
            label: "WS(+684)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ws.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 684,
            "name": "AS",
            label: "AS(+684)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/as.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 378,
            "name": "SM",
            label: "SM(+378)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 221,
            "name": "SN",
            label: "SN(+221)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 248,
            "name": "SC",
            label: "SC(+248)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sc.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 232,
            "name": "SL",
            label: "SL(+232)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sl.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 65,
            "name": "SG",
            label: "SG(+65)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sg.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 963,
            "name": "SY",
            label: "SY(+963)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sy.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 252,
            "name": "SO",
            label: "SO(+252)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/so.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 94,
            "name": "LK",
            label: "LK(+94)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/lk.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 27,
            "name": "ZA",
            label: "ZA(+27)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/za.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 249,
            "name": "SD",
            label: "SD(+249)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sd.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 46,
            "name": "SE",
            label: "SE(+46)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/se.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 41,
            "name": "CH",
            label: "CH(+41)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ch.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 597,
            "name": "SR",
            label: "SR(+597)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/sr.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 66,
            "name": "TH",
            label: "TH(+66)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/th.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 886,
            "name": "TW",
            label: "TW(+886)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/tw.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 255,
            "name": "TZ",
            label: "TZ(+255)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/tz.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 228,
            "name": "TG",
            label: "TG(+228)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/tg.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 676,
            "name": "TO",
            label: "TO(+676)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/to.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 1016,
            "name": "TT",
            label: "TT(+1016)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/tt.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 993,
            "name": "TM",
            label: "TM(+993)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/tm.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 688,
            "name": "TV",
            label: "TV(+688)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/tv.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 256,
            "name": "UG",
            label: "UG(+256)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ug.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 598,
            "name": "UY",
            label: "UY(+598)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/uy.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 737,
            "name": "UZ",
            label: "UZ(+737)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/uz.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 7377,
            "name": "VU",
            label: "VU(+7377)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/vu.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 58,
            "name": "VE",
            label: "VE(+58)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ve.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 84,
            "name": "VN",
            label: "VN(+84)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/vn.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 681,
            "name": "WF",
            label: "WF(+681)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/wf.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 967,
            "name": "YE",
            label: "YE(+967)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/ye.svg"} alt=""
                           className={"flag"}
            />
        },
        {
            value: 260,
            "name": "ZM",
            label: "ZM(+260)",
            "locale": "es-ES",
            flagPath: <img src={PUBLIC_URL + "/img/flags/zm.svg"} alt=""
                           className={"flag"}
            />
        }
    ]
